/**
 * Main Admin Panel component with navigation and routing
 */
import React, { useState } from 'react';
import UserList from './UserList';
import UserDetail from './UserDetail';
import TaskList from './TaskList';
import TaskForm from './TaskForm';
import AuditLogs from './AuditLogs';
import { useAdmin } from '../../contexts/AdminContext';

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState('users');
  const { selectedUser, selectedTask, setSelectedUser, setSelectedTask } = useAdmin();

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Clear selections when switching tabs
    if (tab !== 'users') setSelectedUser(null);
    if (tab !== 'tasks') setSelectedTask(null);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'users':
        return selectedUser ? (
          <UserDetail
            user={selectedUser}
            onBack={() => setSelectedUser(null)}
          />
        ) : (
          <UserList />
        );

      case 'tasks':
        return selectedTask ? (
          <TaskForm
            task={selectedTask}
            onBack={() => setSelectedTask(null)}
          />
        ) : (
          <TaskList />
        );

      case 'audit':
        return <AuditLogs />;

      default:
        return <UserList />;
    }
  };

  return (
    <div style={{ padding: '1rem' }}>
      <header style={{ marginBottom: '2rem' }}>
        <h1>Admin Panel</h1>
        <p>Manage users, tasks, and monitor system activity</p>
      </header>

      {/* Navigation Tabs */}
      <nav style={{ marginBottom: '2rem' }}>
        <div style={{
          display: 'flex',
          borderBottom: '1px solid #ddd',
          gap: '1rem'
        }}>
          {[
            { id: 'users', label: 'Users' },
            { id: 'tasks', label: 'Tasks' },
            { id: 'audit', label: 'Audit Logs' }
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => handleTabChange(tab.id)}
              style={{
                padding: '0.75rem 1rem',
                border: 'none',
                backgroundColor: 'transparent',
                borderBottom: `2px solid ${activeTab === tab.id ? '#007bff' : 'transparent'}`,
                color: activeTab === tab.id ? '#007bff' : '#666',
                cursor: 'pointer',
                fontSize: '1rem',
                fontWeight: activeTab === tab.id ? 'bold' : 'normal'
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </nav>

      {/* Tab Content */}
      <main>
        {renderTabContent()}
      </main>
    </div>
  );
};

export default AdminPanel;